export enum DistrictType {
  Company = 'Company',
  Contractor = 'Contractor',
}
